import { CHAOS_SPREAD } from '../cards/recursive/chaos-spread';
import { HEX_WEAKEN } from '../cards/support/hex-weaken';
import { COLD_SNAP } from '../cards/trap/cold-snap';
import { MIRROR } from '../cards/trap/mirror';
import { SPIKE_WALL } from '../cards/trap/spike-wall';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Legendary tier: 4×4, 5 dice, trap-aware AI.
 * A control boss that denies every answer — the trap-aware AI charges Spike Wall
 * to shred your defence, Cold Snap freezes your best card, Mirror rebounds your
 * debuffs, and Chaos Spread drowns you in scaling poison. Deals little *direct*
 * damage — kills you with attrition and denial. */
export const SPECTRAL_TYRANT: EnemyTemplate = {
  id: 'spectral-tyrant',
  name: 'Spectral Tyrant',
  glyph: '♆', // trident — the denial tyrant
  tier: 'legendary',
  hp: 51,
  loadout: [
    { card: CHAOS_SPREAD, origin: { row: 0, col: 0 }, rotated: false },
    { card: SPIKE_WALL, origin: { row: 0, col: 3 }, rotated: false },
    { card: MIRROR, origin: { row: 2, col: 0 }, rotated: false },
    { card: COLD_SNAP, origin: { row: 2, col: 2 }, rotated: false },
    { card: HEX_WEAKEN, origin: { row: 2, col: 3 }, rotated: false },
  ],
  drops: { gold: 50 },
};
